import { render, staticRenderFns } from "./radio-group-list.component.vue?vue&type=template&id=84369508"
import script from "./radio-group-list.component.vue?vue&type=script&lang=ts"
export * from "./radio-group-list.component.vue?vue&type=script&lang=ts"
import style0 from "./radio-group-list.component.vue?vue&type=style&index=0&id=84369508&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports